import { render } from "./TopbarUserComponent.vue?vue&type=template&id=116458b0&scoped=true&ts=true"
import script from "./TopbarUserComponent.vue?vue&type=script&lang=ts"
export * from "./TopbarUserComponent.vue?vue&type=script&lang=ts"

import "./TopbarUserComponent.vue?vue&type=style&index=0&id=116458b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116458b0"]])

export default __exports__